import { Component, computed, effect, input, Input, OnDestroy, OnInit, Signal } from '@angular/core';
import {
    faAddressBook,
    faArrowLeft,
    faArrowRight,
    faBagsShopping,
    faBars,
    faBoxOpen,
    faBoxUp,
    faCaretDown,
    faCaretUp,
    faCog,
    faCubes,
    faDolly,
    faEllipsisV,
    faFileChartLine,
    faFileInvoice,
    faHome,
    faPlus,
    faRedo,
    faSearch,
    faTimesCircle,
    faTrash,
    faUndo,
    faTruck,
    faComment,
    faSpinnerThird,
    faAngleUp,
    faAngleDown,
    faPrint,
    faExclamationTriangle,
    faAddressCard,
    faCircleInfo,
    faBoxesStacked,
    faArrowUpFromSquare,
    faLock,
    faLockOpen,
    faArrowsSpin,
    faCreditCard,
    faPlusCircle,
    faFile,
    faCopy,
    faRepeat,
    faFileSignature,
    faBarcode,
    faRectangleBarcode,
    faTableList,
    faFileInvoiceDollar,
    faDollarSign,
    faBooks,
    faSeedling,
    faPen,
    faCircle0,
    faCircle1,
    faCircle2,
    faCircle3,
    faCircle4,
    faCircle5,
    faCircle6,
    faCircle7,
    faCircle8,
    faCircle9,
    faSquare0,
    faSquare1,
    faSquare2,
    faSquare3,
    faSquare4,
    faSquare5,
    faSquare6,
    faSquare7,
    faSquare8,
    faSquare9,
    faCirclePlus,
    faCircleMinus,
    faCircleCheck,
    faCircleX,
    faSquarePlus,
    faSquareMinus,
    faSquareCheck,
    faSquareX,
    faTruckContainerEmpty,
    faCamera,
    faXmark,
    faEnvelope,
    faBuilding,
    faKey,
    faGrid2,
    faArrowsRotate,
    faPeopleArrows,
    faPersonFromPortal
} from '@fortawesome/pro-solid-svg-icons';
import {
    faAddressBook as faAddressBookDuoTone,
    faArrowLeft as faArrowLeftDuoTone,
    faArrowRight as faArrowRightDuoTone,
    faBagsShopping as faBagsShoppingDuoTone,
    faBars as faBarsDuoTone,
    faBoxOpen as faBoxOpenDuoTone,
    faBoxUp as faBoxUpDuoTone,
    faCaretDown as faCaretDownDuoTone,
    faCaretUp as faCaretUpDuoTone,
    faCog as faCogDuoTone,
    faCubes as faCubesDuoTone,
    faDolly as faDollyDuoTone,
    faEllipsisV as faEllipsisVDuoTone,
    faFileChartLine as faFileChartLineDuoTone,
    faFileInvoice as faFileInvoiceDuoTone,
    faHome as faHomeDuoTone,
    faPlus as faPlusDuoTone,
    faRedo as faRedoDuoTone,
    faSearch as faSearchDuoTone,
    faTimesCircle as faTimesCircleDuoTone,
    faTrash as faTrashDuoTone,
    faUndo as faUndoDuoTone,
    faTruck as faTruckDuoTone,
    faComment as faCommentDuoTone,
    faSpinnerThird as faSpinnerThirdDuoTone,
    faAngleUp as faAngleUpDuoTone,
    faAngleDown as faAngleDownDuoTone,
    faPrint as faPrintDuoTone,
    faExclamationTriangle as faExclamationTriangleDuoTone,
    faAddressCard as faAddressCardDuoTone,
    faCircleInfo as faCircleInfoDuoTone,
    faBoxesStacked as faBoxesStackedDuoTone,
    faArrowUpFromSquare as faArrowUpFromSquareDuoTone,
    faLock as faLockDuoTone,
    faLockOpen as faLockOpenDuoTone,
    faArrowsSpin as faArrowsSpinDuoTone,
    faPlusCircle as faPlusCircleDuoTone,
    faFile as faFileDuoTone,
    faCopy as faCopyDuoTone,
    faRepeat as faRepeatDuoTone,
    faFileSignature as faFileSignatureDuoTone,
    faBarcode as faBarcodeDuoTone,
    faRectangleBarcode as faRectangleBarcodeDuoTone,
    faTableList as faTableListDuoTone,
    faFileInvoiceDollar as faFileInvoiceDollarDuoTone,
    faDollarSign as faDollarSignDuoTone,
    faBooks as faBooksDuoTone,
    faSeedling as faSeedlingDuoTone,
    faPen as faPenDuoTone,
    faCircle0 as faCircle0DuoTone,
    faCircle1 as faCircle1DuoTone,
    faCircle2 as faCircle2DuoTone,
    faCircle3 as faCircle3DuoTone,
    faCircle4 as faCircle4DuoTone,
    faCircle5 as faCircle5DuoTone,
    faCircle6 as faCircle6DuoTone,
    faCircle7 as faCircle7DuoTone,
    faCircle8 as faCircle8DuoTone,
    faCircle9 as faCircle9DuoTone,
    faSquare0 as faSquare0DuoTone,
    faSquare1 as faSquare1DuoTone,
    faSquare2 as faSquare2DuoTone,
    faSquare3 as faSquare3DuoTone,
    faSquare4 as faSquare4DuoTone,
    faSquare5 as faSquare5DuoTone,
    faSquare6 as faSquare6DuoTone,
    faSquare7 as faSquare7DuoTone,
    faSquare8 as faSquare8DuoTone,
    faSquare9 as faSquare9DuoTone,
    faCirclePlus as faCirclePlusDuoTone,
    faCircleMinus as faCircleMinusDuoTone,
    faCircleX as faCircleXDuoTone,
    faCircleCheck as faCircleCheckDuoTone,
    faSquarePlus as faSquarePlusDuoTone,
    faSquareMinus as faSquareMinusDuoTone,
    faSquareX as faSquareXDuoTone,
    faSquareCheck as faSquareCheckDuoTone,
    faTruckContainerEmpty as faTruckContainerEmptyDuoTone,
    faCamera as faCameraDuoTone,
    faXmark as faXmarkDuoTone,
    faEnvelope as faEnvelopeDuoTone,
    faBuilding as faBuildingDuoTone,
    faKey as faKeyDuoTone,
    faGrid2 as faGrid2DuoTone,
    faArrowsRotate as faArrowsRotateDuoTone,
    faPeopleArrows as faPeopleArrowsDuoTone,
    faPersonFromPortal as faPersonFromPortalDuoTone,
} from '@fortawesome/pro-duotone-svg-icons';
import {
    faAddressBook as faAddressBookLight,
    faArrowLeft as faArrowLeftLight,
    faArrowRight as faArrowRightLight,
    faBagsShopping as faBagsShoppingLight,
    faBars as faBarsLight,
    faBoxOpen as faBoxOpenLight,
    faBoxUp as faBoxUpLight,
    faCaretDown as faCaretDownLight,
    faCaretUp as faCaretUpLight,
    faCog as faCogLight,
    faCubes as faCubesLight,
    faDolly as faDollyLight,
    faEllipsisV as faEllipsisVLight,
    faFileChartLine as faFileChartLineLight,
    faFileInvoice as faFileInvoiceLight,
    faHome as faHomeLight,
    faPlus as faPlusLight,
    faRedo as faRedoLight,
    faSearch as faSearchLight,
    faTimesCircle as faTimesCircleLight,
    faTrash as faTrashLight,
    faUndo as faUndoLight,
    faTruck as faTruckLight,
    faComment as faCommentLight,
    faSpinnerThird as faSpinnerThirdLight,
    faAngleUp as faAngleUpLight,
    faAngleDown as faAngleDownLight,
    faPrint as faPrintLight,
    faExclamationTriangle as faExclamationTriangleLight,
    faAddressCard as faAddressCardLight,
    faCircleInfo as faCircleInfoLight,
    faBoxesStacked as faBoxesStackedLight,
    faArrowUpFromSquare as faArrowUpFromSquareLight,
    faLock as faLockLight,
    faLockOpen as faLockOpenLight,
    faArrowsSpin as faArrowsSpinLight,
    faPlusCircle as faPlusCircleLight,
    faFile as faFileLight,
    faCopy as faCopyLight,
    faRepeat as faRepeatLight,
    faFileSignature as faFileSignatureLight,
    faBarcode as faBarcodeLight,
    faRectangleBarcode as faRectangleBarcodeLight,
    faTableList as faTableListLight,
    faFileInvoiceDollar as faFileInvoiceDollarLight,
    faDollarSign as faDollarSignLight,
    faBooks as faBooksLight,
    faSeedling as faSeedlingLight,
    faPen as faPenLight,
    faCircle0 as faCircle0Light,
    faCircle1 as faCircle1Light,
    faCircle2 as faCircle2Light,
    faCircle3 as faCircle3Light,
    faCircle4 as faCircle4Light,
    faCircle5 as faCircle5Light,
    faCircle6 as faCircle6Light,
    faCircle7 as faCircle7Light,
    faCircle8 as faCircle8Light,
    faCircle9 as faCircle9Light,
    faSquare0 as faSquare0Light,
    faSquare1 as faSquare1Light,
    faSquare2 as faSquare2Light,
    faSquare3 as faSquare3Light,
    faSquare4 as faSquare4Light,
    faSquare5 as faSquare5Light,
    faSquare6 as faSquare6Light,
    faSquare7 as faSquare7Light,
    faSquare8 as faSquare8Light,
    faSquare9 as faSquare9Light,
    faCirclePlus as faCirclePlusLight,
    faCircleMinus as faCircleMinusLight,
    faCircleX as faCircleXLight,
    faCircleCheck as faCircleCheckLight,
    faSquarePlus as faSquarePlusLight,
    faSquareMinus as faSquareMinusLight,
    faSquareX as faSquareXLight,
    faSquareCheck as faSquareCheckLight,
    faTruckContainerEmpty as faTruckContainerEmptyLight,
    faCamera as faCameraLight,
    faXmark as faXmarkLight,
    faEnvelope as faEnvelopeLight,
    faBuilding as faBuildingLight,
    faKey as faKeyLight,
    faGrid2 as faGrid2Light,
    faArrowsRotate as faArrowsRotateLight,
    faPeopleArrows as faPeopleArrowsLight,
    faPersonFromPortal as faPersonFromPortalLight,
} from '@fortawesome/pro-light-svg-icons';
import { faGoogle, faAmazon, faFacebook, faApple } from '@fortawesome/free-brands-svg-icons';
import { IconEnum } from '../../../enum/icon.enum';
import { IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectIconSet, selectThemeFlag } from '../../../store/profile/profile.state';
import { faCcAmex, faCcDiscover, faCcJcb, faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: [ './icon.component.scss' ],
    imports: [FontAwesomeModule]
})
export class IconComponent {

    @Input()
    public icon: IconEnum;

    @Input()
    public spin = false;

    @Input()
    public pulse = false;

    public beatFade = input<boolean>(false);

    @Input()
    public number: number = null;

    @Input()
    public numberType: 'circle' | 'square' = null;

    constructor(private store: Store<AppState>) {}

    useDuotoneIcons = this.store.selectSignal(selectThemeFlag('icons:duotone'));
    useLightIcons = this.store.selectSignal(selectThemeFlag('icons:light'));
    themeIconSet = computed(() => this.useDuotoneIcons() ? 'fa-duotone' : this.useLightIcons() ? 'fa-light' : 'fa-solid');

    public iconDefinition: IconDefinition = faFile;
    public iconDefinition2: IconDefinition = faFile;
    public iconNumberDefinitions: IconDefinition[] = [];

    classes: Signal<string[]> = computed(() => {
        return this.beatFade() ? [ 'fa-beat-fade', 'fa-icon' ] : [ 'fa-icon' ];
    });

    protected iconSet = 'default';
    protected stack = false;
    protected stack1 = '2x';
    protected stack2 = '1x';

    private e = effect(() => {
        const name = this.themeIconSet();
        if (this.icon) {
            switch (this.icon) {
                case 'waybill':
                    this.iconDefinition = this.getIcon('file', name);
                    this.iconDefinition2 = this.getIcon('rectangle-barcode', name);
                    this.stack = true;
                    break;
                case 'quote-summary':
                    this.iconDefinition = this.getIcon('file', name);
                    this.iconDefinition2 = this.getIcon('table-list', name);
                    this.stack = true;
                    break;
                case 'commercial-invoice':
                    this.iconDefinition = this.getIcon('file', name);
                    this.iconDefinition2 = this.getIcon('dollar-sign', name);
                    this.stack = true;
                    break;
                default:
                    this.iconDefinition = this.getIcon(this.icon, name);
                    break;
            }
        }
        if (this.number !== null) {
            this.iconNumberDefinitions = this.getNumberIcons().map(icon => this.getIcon(icon, name));
        }
    });


    protected fontAwesomeDuoTone(icon: string): any {
        switch (icon) {
            case 'search':
                return faSearchDuoTone;
            case 'menu':
                return faBarsDuoTone;
            case 'back':
                return faArrowLeftDuoTone;
            case 'pickup':
                return faDollyDuoTone;
            case 'shipment':
                return faBoxUpDuoTone;
            case 'quote':
                return faBoxOpenDuoTone;
            case 'dashboard':
                return faHomeDuoTone;
            case 'report':
                return faFileChartLineDuoTone;
            case 'invoice':
                return faFileInvoiceDuoTone;
            case 'address-books':
                return faAddressBookDuoTone;
            case 'orders':
                return faBagsShoppingDuoTone;
            case 'package-library':
                return faCubesDuoTone;
            case 'settings':
                return faCogDuoTone;
            case 'add':
                return faPlusDuoTone;
            case 'trash':
                return faTrashDuoTone;
            case 'context-menu':
                return faEllipsisVDuoTone;
            case 'delete':
                return faTimesCircleDuoTone;
            case 'undo':
                return faUndoDuoTone;
            case 'redo':
                return faRedoDuoTone;
            case 'caret-up':
                return faCaretUpDuoTone;
            case 'caret-down':
                return faCaretDownDuoTone;
            case 'arrow-right':
                return faArrowRightDuoTone;
            case 'truck':
                return faTruckDuoTone;
            case 'courier-note':
                return faCommentDuoTone;
            case 'spinner':
                return faSpinnerThirdDuoTone;
            case 'angle-up':
                return faAngleUpDuoTone;
            case 'angle-down':
                return faAngleDownDuoTone;
            case 'cog':
                return faCogDuoTone;
            case 'print':
                return faPrintDuoTone;
            case 'warning':
                return faExclamationTriangleDuoTone;
            case 'notice':
                return faCircleInfoDuoTone;
            case 'address-card':
                return faAddressCardDuoTone;
            case 'batch':
                return faBoxesStackedDuoTone;
            case 'share':
                return faArrowUpFromSquareDuoTone;
            case 'lock':
                return faLockDuoTone;
            case 'lock-open':
                return faLockOpenDuoTone;
            case 'arrows-spin':
                return faArrowsSpinDuoTone;
            case 'cc-visa':
                return faCcVisa;
            case 'cc-mastercard':
                return faCcMastercard;
            case 'cc-jcb':
                return faCcJcb;
            case 'cc-discover':
                return faCcDiscover;
            case 'cc-amex':
                return faCcAmex;
            case 'credit-card':
                return faCreditCard;
            case 'add-circle':
                return faPlusCircleDuoTone;
            case 'file':
                return faFileDuoTone;
            case 'copy':
                return faCopyDuoTone;
            case 'return':
                return faRepeatDuoTone;
            case 'proof-of-delivery':
                return faFileSignatureDuoTone;
            case 'barcode':
                return faBarcodeDuoTone;
            case 'table-list':
                return faTableListDuoTone;
            case 'rectangle-barcode':
                return faRectangleBarcodeDuoTone;
            case 'commercial-invoice':
                return faFileInvoiceDollarDuoTone;
            case 'dollar-sign':
                return faDollarSignDuoTone;
            case 'books':
                return faBooksDuoTone;
            case 'seedling':
                return faSeedlingDuoTone;
            case 'pen':
                return faPenDuoTone;
            case 'circle-0':
                return faCircle0DuoTone;
            case 'circle-1':
                return faCircle1DuoTone;
            case 'circle-2':
                return faCircle2DuoTone;
            case 'circle-3':
                return faCircle3DuoTone;
            case 'circle-4':
                return faCircle4DuoTone;
            case 'circle-5':
                return faCircle5DuoTone;
            case 'circle-6':
                return faCircle6DuoTone;
            case 'circle-7':
                return faCircle7DuoTone;
            case 'circle-8':
                return faCircle8DuoTone;
            case 'circle-9':
                return faCircle9DuoTone;
            case 'square-0':
                return faSquare0DuoTone;
            case 'square-1':
                return faSquare1DuoTone;
            case 'square-2':
                return faSquare2DuoTone;
            case 'square-3':
                return faSquare3DuoTone;
            case 'square-4':
                return faSquare4DuoTone;
            case 'square-5':
                return faSquare5DuoTone;
            case 'square-6':
                return faSquare6DuoTone;
            case 'square-7':
                return faSquare7DuoTone;
            case 'square-8':
                return faSquare8DuoTone;
            case 'square-9':
                return faSquare9DuoTone;
            case 'circle-plus':
                return faCirclePlusDuoTone;
            case 'circle-minus':
                return faCircleMinusDuoTone;
            case 'circle-x':
                return faCircleXDuoTone;
            case 'circle-check':
                return faCircleCheckDuoTone;
            case 'square-plus':
                return faSquarePlusDuoTone;
            case 'square-minus':
                return faSquareMinusDuoTone;
            case 'square-x':
                return faSquareXDuoTone;
            case 'square-check':
                return faSquareCheckDuoTone;
            case 'truck-empty':
                return faTruckContainerEmptyDuoTone;
            case 'camera':
                return faCameraDuoTone;
            case 'xmark':
                return faXmarkDuoTone;
            case 'envelope':
                return faEnvelopeDuoTone;
            case 'building':
                return faBuildingDuoTone;
            case 'key':
                return faKeyDuoTone;
            case 'grid-2':
                return faGrid2DuoTone;
            case 'refresh':
                return faArrowsRotateDuoTone;
            case 'google':
                return faGoogle;
            case 'amazon':
                return faAmazon;
            case 'facebook':
                return faFacebook;
            case 'apple':
                return faApple;
            case 'person-switch':
                return faPeopleArrowsDuoTone;
            case 'person-exit':
                return faPersonFromPortalDuoTone;
            default:
                return null;
        }
    }

    protected fontAwesomeSolid(icon: string): any {
        switch (icon) {
            case 'search':
                return faSearch;
            case 'menu':
                return faBars;
            case 'back':
                return faArrowLeft;
            case 'pickup':
                return faDolly;
            case 'shipment':
                return faBoxUp;
            case 'quote':
                return faBoxOpen;
            case 'dashboard':
                return faHome;
            case 'report':
                return faFileChartLine;
            case 'invoice':
                return faFileInvoice;
            case 'address-books':
                return faAddressBook;
            case 'orders':
                return faBagsShopping;
            case 'package-library':
                return faCubes;
            case 'settings':
                return faCog;
            case 'add':
                return faPlus;
            case 'trash':
                return faTrash;
            case 'context-menu':
                return faEllipsisV;
            case 'delete':
                return faTimesCircle;
            case 'undo':
                return faUndo;
            case 'redo':
                return faRedo;
            case 'caret-up':
                return faCaretUp;
            case 'caret-down':
                return faCaretDown;
            case 'arrow-right':
                return faArrowRight;
            case 'truck':
                return faTruck;
            case 'courier-note':
                return faComment;
            case 'spinner':
                return faSpinnerThird;
            case 'angle-up':
                return faAngleUp;
            case 'angle-down':
                return faAngleDown;
            case 'cog':
                return faCog;
            case 'print':
                return faPrint;
            case 'warning':
                return faExclamationTriangle;
            case 'notice':
                return faCircleInfo;
            case 'address-card':
                return faAddressCard;
            case 'batch':
                return faBoxesStacked;
            case 'share':
                return faArrowUpFromSquare;
            case 'lock':
                return faLock;
            case 'lock-open':
                return faLockOpen;
            case 'arrows-spin':
                return faArrowsSpin;
            case 'cc-visa':
                return faCcVisa;
            case 'cc-mastercard':
                return faCcMastercard;
            case 'cc-jcb':
                return faCcJcb;
            case 'cc-discover':
                return faCcDiscover;
            case 'cc-amex':
                return faCcAmex;
            case 'credit-card':
                return faCreditCard;
            case 'add-circle':
                return faPlusCircle;
            case 'file':
                return faFile;
            case 'copy':
                return faCopy;
            case 'return':
                return faRepeat;
            case 'proof-of-delivery':
                return faFileSignature;
            case 'barcode':
                return faBarcode;
            case 'rectangle-barcode':
                return faRectangleBarcode;
            case 'table-list':
                return faTableList;
            case 'commercial-invoice':
                return faFileInvoiceDollar;
            case 'dollar-sign':
                return faDollarSign;
            case 'books':
                return faBooks;
            case 'seedling':
                return faSeedling;
            case 'pen':
                return faPen;
            case 'circle-0':
                return faCircle0;
            case 'circle-1':
                return faCircle1;
            case 'circle-2':
                return faCircle2;
            case 'circle-3':
                return faCircle3;
            case 'circle-4':
                return faCircle4;
            case 'circle-5':
                return faCircle5;
            case 'circle-6':
                return faCircle6;
            case 'circle-7':
                return faCircle7;
            case 'circle-8':
                return faCircle8;
            case 'circle-9':
                return faCircle9;
            case 'square-0':
                return faSquare0;
            case 'square-1':
                return faSquare1;
            case 'square-2':
                return faSquare2;
            case 'square-3':
                return faSquare3;
            case 'square-4':
                return faSquare4;
            case 'square-5':
                return faSquare5;
            case 'square-6':
                return faSquare6;
            case 'square-7':
                return faSquare7;
            case 'square-8':
                return faSquare8;
            case 'square-9':
                return faSquare9;
            case 'circle-plus':
                return faCirclePlus;
            case 'circle-minus':
                return faCircleMinus;
            case 'circle-x':
                return faCircleX;
            case 'circle-check':
                return faCircleCheck;
            case 'square-plus':
                return faSquarePlus;
            case 'square-minus':
                return faSquareMinus;
            case 'square-x':
                return faSquareX;
            case 'square-check':
                return faSquareCheck;
            case 'truck-empty':
                return faTruckContainerEmpty;
            case 'camera':
                return faCamera;
            case 'xmark':
                return faXmark;
            case 'envelope':
                return faEnvelope;
            case 'building':
                return faBuilding;
            case 'key':
                return faKey;
            case 'grid-2':
                return faGrid2;
            case 'refresh':
                return faArrowsRotate;
            case 'google':
                return faGoogle;
            case 'amazon':
                return faAmazon;
            case 'facebook':
                return faFacebook;
            case 'apple':
                return faApple;
            case 'person-switch':
                return faPeopleArrows;
            case 'person-exit':
                return faPersonFromPortal;
            default:
                return null;
        }
    }

    protected fontAwesomeLight(icon: string): any {
        switch (icon) {
            case 'search':
                return faSearchLight;
            case 'menu':
                return faBarsLight;
            case 'back':
                return faArrowLeftLight;
            case 'pickup':
                return faDollyLight;
            case 'shipment':
                return faBoxUpLight;
            case 'quote':
                return faBoxOpenLight;
            case 'dashboard':
                return faHomeLight;
            case 'report':
                return faFileChartLineLight;
            case 'invoice':
                return faFileInvoiceLight;
            case 'address-books':
                return faAddressBookLight;
            case 'orders':
                return faBagsShoppingLight;
            case 'package-library':
                return faCubesLight;
            case 'settings':
                return faCogLight;
            case 'add':
                return faPlusLight;
            case 'trash':
                return faTrashLight;
            case 'context-menu':
                return faEllipsisVLight;
            case 'delete':
                return faTimesCircleLight;
            case 'undo':
                return faUndoLight;
            case 'redo':
                return faRedoLight;
            case 'caret-up':
                return faCaretUpLight;
            case 'caret-down':
                return faCaretDownLight;
            case 'arrow-right':
                return faArrowRightLight;
            case 'truck':
                return faTruckLight;
            case 'courier-note':
                return faCommentLight;
            case 'spinner':
                return faSpinnerThirdLight;
            case 'angle-up':
                return faAngleUpLight;
            case 'angle-down':
                return faAngleDownLight;
            case 'cog':
                return faCogLight;
            case 'print':
                return faPrintLight;
            case 'warning':
                return faExclamationTriangleLight;
            case 'notice':
                return faCircleInfoLight;
            case 'address-card':
                return faAddressCardLight;
            case 'batch':
                return faBoxesStackedLight;
            case 'share':
                return faArrowUpFromSquareLight;
            case 'lock':
                return faLockLight;
            case 'lock-open':
                return faLockOpenLight;
            case 'arrows-spin':
                return faArrowsSpinLight;
            case 'cc-visa':
                return faCcVisa;
            case 'cc-mastercard':
                return faCcMastercard;
            case 'cc-jcb':
                return faCcJcb;
            case 'cc-discover':
                return faCcDiscover;
            case 'cc-amex':
                return faCcAmex;
            case 'credit-card':
                return faCreditCard;
            case 'add-circle':
                return faPlusCircleLight;
            case 'file':
                return faFileLight;
            case 'copy':
                return faCopyLight;
            case 'return':
                return faRepeatLight;
            case 'proof-of-delivery':
                return faFileSignatureLight;
            case 'barcode':
                return faBarcodeLight;
            case 'rectangle-barcode':
                return faRectangleBarcodeLight;
            case 'table-list':
                return faTableListLight;
            case 'commercial-invoice':
                return faFileInvoiceDollarLight;
            case 'dollar-sign':
                return faDollarSignLight;
            case 'books':
                return faBooksLight;
            case 'seedling':
                return faSeedlingLight;
            case 'pen':
                return faPenLight;
            case 'circle-0':
                return faCircle0Light;
            case 'circle-1':
                return faCircle1Light;
            case 'circle-2':
                return faCircle2Light;
            case 'circle-3':
                return faCircle3Light;
            case 'circle-4':
                return faCircle4Light;
            case 'circle-5':
                return faCircle5Light;
            case 'circle-6':
                return faCircle6Light;
            case 'circle-7':
                return faCircle7Light;
            case 'circle-8':
                return faCircle8Light;
            case 'circle-9':
                return faCircle9Light;
            case 'square-0':
                return faSquare0Light;
            case 'square-1':
                return faSquare1Light;
            case 'square-2':
                return faSquare2Light;
            case 'square-3':
                return faSquare3Light;
            case 'square-4':
                return faSquare4Light;
            case 'square-5':
                return faSquare5Light;
            case 'square-6':
                return faSquare6Light;
            case 'square-7':
                return faSquare7Light;
            case 'square-8':
                return faSquare8Light;
            case 'square-9':
                return faSquare9Light;
            case 'circle-plus':
                return faCirclePlusLight;
            case 'circle-minus':
                return faCircleMinusLight;
            case 'circle-x':
                return faCircleXLight;
            case 'circle-check':
                return faCircleCheckLight;
            case 'square-plus':
                return faSquarePlusLight;
            case 'square-minus':
                return faSquareMinusLight;
            case 'square-x':
                return faSquareXLight;
            case 'square-check':
                return faSquareCheckLight;
            case 'truck-empty':
                return faTruckContainerEmptyLight;
            case 'camera':
                return faCameraLight;
            case 'xmark':
                return faXmarkLight;
            case 'envelope':
                return faEnvelopeLight;
            case 'building':
                return faBuildingLight;
            case 'key':
                return faKeyLight;
            case 'grid-2':
                return faGrid2Light;
            case 'refresh':
                return faArrowsRotateLight;
            case 'google':
                return faGoogle;
            case 'amazon':
                return faAmazon;
            case 'facebook':
                return faFacebook;
            case 'apple':
                return faApple;
            case 'person-switch':
                return faPeopleArrowsLight;
            case 'person-exit':
                return faPersonFromPortalLight;
            default:
                return null;
        }
    }

    protected fontAwesomeClasses(): string[] {
        if (this.beatFade()) {
            return [ 'fa-beat-fade' ];
        }
        return [];
    }

    protected getIcon(icon: IconEnum, iconSet: string): IconDefinition {
        switch (iconSet) {
            case 'fa-duotone':
                return this.fontAwesomeDuoTone(icon);
            case 'fa-light':
                return this.fontAwesomeLight(icon);
            case 'fa-solid':
            default:
                return this.fontAwesomeSolid(icon);
        }
    }

    isStack(): boolean {
        return this.stack && this.number === null;
    }

    isRegular(): boolean {
        return !this.stack && this.number === null;
    }

    isNumber(): boolean {
        return this.number !== null;
    }

    getNumberIcons(): IconEnum[] {
        if (this.number === null) {
            return [];
        }
        let num = this.number;
        let output = [];
        while (num > 0) {
            const glyph = num % 10;
            const name = (this.numberType || 'circle') + '-' + glyph.toString();
            output = [ name, ...output ];
            num = Math.floor(num / 10);
        }
        return output;
    }

}
